import { render, staticRenderFns } from "./IncidentTripLiveTrackingCell.vue?vue&type=template&id=2c8c255f&scoped=true"
import script from "./IncidentTripLiveTrackingCell.vue?vue&type=script&lang=js"
export * from "./IncidentTripLiveTrackingCell.vue?vue&type=script&lang=js"
import style0 from "./IncidentTripLiveTrackingCell.vue?vue&type=style&index=0&id=2c8c255f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c255f",
  null
  
)

export default component.exports